<template>
  <div class="meal-reservation">
    <!-- 顶部tab -->
    <div class="page-header">
      <van-tabs v-model:active="state.activeTab" type="card" @click-tab="onTabChange">
        <van-tab title="套餐订单" :name="0" />
        <van-tab title="饮品订单" :name="1" />
    </van-tabs>
    </div>
    
    <!-- 预约列表 -->
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.isFinish"
        finished-text="没有更多了"
        @load="getReservationList"
      >
        <div class="reservation-list" v-if="state.activeTab == 0">
          <div class="list-item" v-for="(item, index) in state.reservationList" :key="index">
            <!-- 状态标签 -->
            <div class="status-tag" :class="'status-tag-' + item.status">
              {{ getStatusText(item.status) }}
            </div>
            <div class="item-header">
              <div class="date">{{ formateDate(item.plannedDiningTime) }}</div>
            </div>
            <div class="item-content">
              <div class="meal-info">
                <span class="meal-period">{{ formateMealPeriod(item.mealPeriod) }}：</span>
                <span class="meal-package">{{ item.mealPackage }}</span>
                <span class="meal-quantity">×{{ item.quantity }}</span>
              </div>
              <div class="location" style="height: 32px; line-height: 32px">
                  {{ item.deliveryAddress }}
                  <div v-if="canOperateReservation(item.plannedDiningTime) && item.status == 0" class="item-footer btn-row">
                      <van-button 
                      size="small" 
                      type="default" 
                      class="footer-btn cancel-btn"
                      @click="handleCancel(item)"
                      >取消</van-button>
                      <van-button 
                      size="small" 
                      type="primary" 
                      class="footer-btn edit-btn"
                      @click="handleEdit(item)"
                      >修改</van-button>
                  </div>
              </div>
            </div>
          </div>
          <EmptyDataCard
            style="margin-top: 88px"
            v-show="!state.reservationList.length && !state.loading"
          />
        </div>
        <div class="reservation-list" v-if="state.activeTab == 1">
          <div class="list-item" v-for="(item, index) in state.reservationList" :key="index">
            <!-- 状态标签 -->
            <div class="status-tag" :class="'status-tag-1-' + item.status">
              {{ getStatusDrinkText(item.status) }}
            </div>
            <div class="item-header">
              <div class="location">{{ item.deliveryAddress }}</div>
            </div>
            
            <div class="item-content">
              <div style="display: flex; justify-content: space-between; width: 100%; align-items: flex-start;">
                  <div class="drink-info-list">
                  <div class="drink-info-row" v-for="(d, idx) in item.detailList" :key="idx">
                    <span class="drink-name">{{ d.drinkName }}</span>
                    <span v-if="d.iceLevel" class="drink-spec">-{{ getIceLevelName(d.iceLevel) }}</span>
                    <span class="drink-qty">×{{ d.quantity }}</span>
                  </div>
                </div>
                <div class="drink-top-summary-row">
                  <span class="drink-amount">￥{{ item.totalAmount }}</span>
                  <span class="drink-count">共{{ item.detailList && item.detailList.length ? item.detailList.reduce((sum, d) => sum + (d.quantity || 0), 0) : 0 }}杯</span>
                </div>
              </div>
              
              <div class="drink-bottom-row">
                <div class="drink-time">{{ item.plannedDeliveryTime ? item.plannedDeliveryTime.slice(0, 16).replace('T', ' ') : '-' }}</div>
                <div v-if="item.status == 0" class="item-footer btn-row">
                  <van-button 
                    size="small" 
                    type="default" 
                    class="footer-btn cancel-btn"
                    @click="handleCancelDrink(item)"
                  >取消</van-button>
                  <van-button 
                    size="small" 
                    type="primary" 
                    class="footer-btn edit-btn"
                    @click="handleEditDrink(item)"
                  >编辑</van-button>
                </div>
              </div>
              
            </div>
          </div>
          <EmptyDataCard
            style="margin-top: 88px"
            v-show="!state.reservationList.length && !state.loading"
          />
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- 底部预约按钮 -->
    <!-- <div class="bottom-button">
      <van-button type="primary" class="reserve-btn" @click="handleReserve">立即预约</van-button>
    </div> -->
  </div>
</template>

<script>
import { defineComponent, reactive, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { showDialog, showNotify } from 'vant'
import EmptyDataCard from '@/components/EmptyDataCard.vue'
import { getMealReservationList, cancelMealReservation, querySyDrinkPageList, updateStatusSyDrinkReservation } from '@/api/meal'
import dayjs from 'dayjs'
import { postSyparamSelectList } from "@/api/report";
import { queryGetEnum } from "@/api/user";


export default defineComponent({
  name: 'MealReservation',
  
  components: {
    EmptyDataCard
  },

  setup() {
    const route = useRoute();
    const router = useRouter()
    const state = reactive({
      reservationList: [],
      loading: false,
      refreshing: false,
      page: {
        pageIndex: 1,
        pageSize: 10
      },
      isFinish: false,
      userId: null,
      realName: null,
      phone: null,
      limitTime: '11:00',
      activeTab: 0 // 0:套餐订单 1:饮品订单
    })

    const formateDate = (date) => {
        return dayjs(date).format('YYYY-MM-DD')
    }

    const iceLevelEnum = ref([]);
    const drinkStatusEnum = ref({});
    // 获取冰度枚举
    const getIceLevelEnum = async () => {
      const result = await queryGetEnum({ enumName: "IceLevelEnum" });
      for (let i in result.data) {
        iceLevelEnum.value = result.data;
      }
    };
    // 获取饮品订单状态枚举
    const getDrinkStatusEnum = async () => {
      const result = await queryGetEnum({ enumName: "DrinkReservationStatusEnum" });
      if (result && result.data) {
        drinkStatusEnum.value = result.data;
      }
    };
    const getIceLevelName = (id) => iceLevelEnum.value[id];
    // 动态获取饮品订单状态文案
    const getStatusDrinkText = (status) => {
      return drinkStatusEnum.value[status] || status;
    }

    const getStatusText = (status) => {
      const statusMap = {
        0: '待送餐',
        1: '已送餐',
        2: '已取消'
      }
      return statusMap[status]
    }

    const formateMealPeriod = (mealPeriod) => {
        const mealPeriodText = {
            1: '早餐',
            2: '午餐',
            3: '晚餐',
            4: '夜宵'
          }
        return mealPeriodText[mealPeriod]
    }

    // 获取预约列表数据
    const getReservationList = async () => {
      try {
        state.loading = true
        let result
        if (state.activeTab === 0) {
          result = await getMealReservationList({
            page: {
              ...state.page
            },
            userId: state.userId
          })
        } else {
          result = await querySyDrinkPageList({
            page: {
              ...state.page
            },
            userId: state.userId
          })
        }
        state.loading = false
        if (result.code === '00') {
          if (state.refreshing) {
            state.reservationList = result.data.list
          } else {
            state.reservationList = [...state.reservationList, ...result.data.list]
          }
          if (state.page.pageIndex >= result.data.pages) {
            state.isFinish = true
          } else {
            state.page.pageIndex++
          }
        } else {
          // showNotify({ type: 'warning', message: result.message })
        }
      } catch (error) {
        state.loading = false
        state.isFinish = true // 防止接口报错时死循环加载
        console.error('获取预约列表失败:', error)
        // showNotify({ type: 'danger', message: '获取预约列表失败' })
      }
    }

    // tab切换
    const onTabChange = ({name}) => {
      console.log('onTabChange', name)
      state.activeTab = Number(name)
      state.page.pageIndex = 1
      state.isFinish = false // 切换tab时允许重新加载
      state.reservationList = []
      getReservationList()
    }

    // 判断是否允许操作预约
    const canOperateReservation = (plannedDiningTime) => {
      const now = dayjs();
      const today = now.startOf('day');
      // 解析 state.limitTime（格式如 '11:00'）
      const [limitHour, limitMinute] = state.limitTime.split(':').map(Number);
      const limitTime = today.add(limitHour, 'hour').add(limitMinute || 0, 'minute');
      const plannedDate = dayjs(plannedDiningTime).startOf('day');
      const diffDays = plannedDate.diff(today, 'day');
      if (now.isBefore(limitTime)) {
        // 限定时间前，只能操作明天及以后
        return diffDays >= 1;
      } else {
        // 限定时间后，只能操作后天及以后
        return diffDays >= 2;
      }
    }

    // 下拉刷新
    const onRefresh = async () => {
      state.refreshing = true
      state.page.pageIndex = 1
      state.isFinish = false // 下拉刷新时允许重新加载
      await getReservationList()
      state.refreshing = false
    }

    const handleCancelDrink = (item) => {
      console.log('handleCancelDrink', item)
      showDialog({
        title: '取消预约',
        message: '确定要取消该预约吗？',
        showCancelButton: true
      }).then(async () => {
        try {
          const result = await updateStatusSyDrinkReservation({
            id: item.id,
            status: 3
          })
          if (result.code === '00') {
            showNotify({ type: 'success', message: '取消预约成功' })
            onRefresh()
          } else {
            showNotify({ type: 'warning', message: result.message })
          }
        } catch (error) {
          console.error('取消预约失败:', error)
          showNotify({ type: 'danger', message: '取消预约失败' })
        }
      }).catch(() => {
        console.log('取消')
      })
    }
    const handleEditDrink = (item) => {
      router.push({
        path: '/drink-menu',
        query: {
          editData: encodeURIComponent(JSON.stringify(item)),
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    const handleCancel = (item) => {
      if (!canOperateReservation(item.plannedDiningTime)) {
        showNotify({ type: 'warning', message: '当前不可操作该预约，请在允许的时间段内操作' })
        return
      }
      showDialog({
        title: '取消预约',
        message: '确定要取消该预约吗？',
        showCancelButton: true
      }).then(async () => {
        try {
          const result = await cancelMealReservation({
            id: item.id
          })
          if (result.code === '00') {
            showNotify({ type: 'success', message: '取消预约成功' })
            onRefresh()
          } else {
            showNotify({ type: 'warning', message: result.message })
          }
        } catch (error) {
          console.error('取消预约失败:', error)
          showNotify({ type: 'danger', message: '取消预约失败' })
        }
      }).catch(() => {
        console.log('取消')
      })
    }

    const handleEdit = (item) => {
      if (!canOperateReservation(item.plannedDiningTime)) {
        showNotify({ type: 'warning', message: '当前该预约不可操作，请在允许的时间段内操作' })
        return
      }
      router.push({
        path: '/meal/edit',
        query: {
          id: item.id,
          info: JSON.stringify(item),
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    const handleReserve = () => {
      router.push({
        path: '/meal/reserve',
        query: {
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    onMounted(() => {
      if(route?.query?.token) {
        localStorage.setItem('token', route?.query?.token)
      }
      if(route?.query?.userId) {
        state.userId = route?.query?.userId
      }
      if(route?.query?.realName) {
        state.realName = route?.query?.realName
      }
      if(route?.query?.phone) {
        state.phone = route?.query?.phone
      }

      if(route?.query?.type) {
        state.activeTab = Number(route?.query?.type ?? 0)
      }

      
      getReservationList()
      gettimeLimit()
      getIceLevelEnum()
      getDrinkStatusEnum()
    })

    const handleExclusiveRecipe = () => {
      router.push({
        path: '/meal/exclusive-recipe',
        query: {
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    const gettimeLimit = async () => {
      // 获取送餐地点选项
      try {
        const res = await postSyparamSelectList({ bigCode: "timeLimit" });
        if (res && Array.isArray(res.data)) {
          state.limitTime = res.data[0]?.bigDesc ?? '11:00'
        }
      } catch (e) {
        state.limitTime = '11:00'
      }
    };

    return {
      state,
      getStatusText,
      handleCancel,
      handleEdit,
      handleReserve,
      onRefresh,
      formateDate,
      formateMealPeriod,
      handleExclusiveRecipe,
      getReservationList,
      canOperateReservation,
      onTabChange,
      iceLevelEnum,
      getIceLevelName,
      getStatusDrinkText,
      drinkStatusEnum,
      getDrinkStatusEnum,
      handleCancelDrink,
      handleEditDrink
    }
  }
})
</script>

<style lang="scss" scoped>
.meal-reservation {
  min-height: 100vh;
  background: #e9f1f8;
  padding: 12px 8px 100px 8px;
  box-sizing: border-box;

  .reservation-list {
    /* 不设置高度和overflow，让页面整体滚动，van-list默认监听window滚动 */
    .list-item {
      position: relative;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.06);
      padding: 20px 16px;
      margin-bottom: 12px;
      min-height: 92px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      .status-tag {
        position: absolute;
        top: 0;
        right: 0;
        width: 88px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 8px 0 38px;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        background: #ff9800;
        z-index: 2;
        &-0 {
          background: #ff9800;
        }
        &-1 {
          background: #07c160;
        }
        &-2 {
          background: #bdbdbd;
        }

        &-1-0 {
          background: #ff9800;
        }
        &-1-1 {
          background: #E6A23C;
        }
        &-1-2 {
          background: #07c160;
        }
        &-1-3 {
          background: #bdbdbd;
        }
        
      }

      .item-header {
        width: 100%;
        margin-bottom: 18px;
        display: flex;
        align-items: flex-start;
        .date {
          font-size: 19px;
          font-weight: 500;
          color: #000000;
          text-align: left;
        }
      }

      .item-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .meal-info {
          font-size: 16px;
          margin-bottom: 8px;
          color: #2F8ED4;
          .meal-period {
            font-weight: 500;
          }
          .meal-package {
            font-weight: 500;
          }
          .meal-quantity {
            font-weight: 500;
          }
        }
        .location {
          font-size: 15px;
          color: #888;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
        }
      }

      .item-footer.btn-row {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        margin-top: 0;
        margin-bottom: 0;
        .footer-btn {
          height: 32px;
          border-radius: 8px !important;
          font-size: 15px;
          font-weight: 500;
          padding: 0 18px;
          min-width: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cancel-btn {
          background: #fff !important;
          color: #013152 !important;
          border: 1.5px solid #013152 !important;
        }
        .edit-btn {
          background: #013152 !important;
          color: #fff !important;
          border: none !important;
        }
      }
    }
  }

  .bottom-button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 0 32px 0;
    display: flex;
    justify-content: center;
    z-index: 10;
    .reserve-btn {
      width: calc(100vw - 128px);
      height: 44px;
      font-size: 16px;
      border-radius: 4px;
      border: 1px solid #013152;
      font-weight: 500;
      letter-spacing: 1px;
      background: #013152;
      
    }
  }
}

.page-header {
  padding: 12px;
  margin: 0 68px;
}

.drink-info-list {
  width: 100%;
  margin-bottom: 8px;
  .drink-info-row {
    font-size: 16px;
    color: #2F8ED4;
    margin-bottom: 2px;
    text-align: left;
    .drink-name {
      font-weight: 500;
    }
    .drink-spec {
      margin-left: 4px;
      color: #888;
      font-size: 14px;
    }
    .drink-qty {
      margin-left: 8px;
      font-weight: 500;
    }
  }
}
.drink-top-summary-row {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  margin: 6px 0 2px 0;
  font-size: 16px;
  .drink-amount {
    color: #000;
    font-size: 17px;
    font-weight: 500;
    margin-right: 16px;
  }
  .drink-count {
    color: #888;
    font-size: 15px;
    margin-top: 2px;
    margin-bottom: 4px;
  }
}
.drink-bottom-row {
  display: flex;
  justify-content:space-between;
  align-items: center;
  font-size: 15px;
  color: #888;
  margin-bottom: 0;
  width: 100%;
  .drink-time {
    color: #888;
    font-size: 15px;
  }
}
</style> 